import { capitalizeFirstWord } from '../../utils/utils';
import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';

function NRTitleWithRightTotal({ title, totalCount = 0, handleTotalClick, titleComponent, showTotal = true }) {
  const theme = useTheme();
  const isClickable = !!totalCount && !!handleTotalClick;

  return (
    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: theme.spacing(1) }}>
      {titleComponent}
      {!titleComponent && (
        <Box>
          <Typography variant={'subtitle1'}>{capitalizeFirstWord(title)}</Typography>
        </Box>
      )}
      {showTotal && (
        <Box sx={{ cursor: 'default' }}>
          <Box
            component={'span'}
            sx={isClickable ? { cursor: 'pointer', color: theme.palette.blue.link } : undefined}
            onClick={isClickable ? handleTotalClick : null}
          >
            {totalCount}
          </Box>{' '}
          Total
        </Box>
      )}
    </Box>
  );
}

export default NRTitleWithRightTotal;
